import type en from './en';

type Messages = Record<keyof typeof en, string>;

const or: Messages = {
  'board.return.context': 'ଅନ୍ୟ କାମରେ ସହାୟତା',
  'board.return.helping': 'ଏହି କାମ {owner}ଙ୍କୁ ସହାୟତା କରୁଛି: {title}',
  'board.return.action': 'ମୋ ଭାଗ ସରିଛି — ଅନୁରୋଧକାରୀଙ୍କୁ ଫେରାନ୍ତୁ',
  'board.return.guidance': 'ଏହା ସହାୟକ କାମକୁ ଆପଣଙ୍କ ବୋର୍ଡରୁ, ସମ୍ପୂର୍ଣ୍ଣ ବିଭାଗରୁ ମଧ୍ୟ, ହଟାଇ ତାହାର ଇତିହାସ ରଖେ। ଆପଣଙ୍କ ସନ୍ଦେଶ ଅନୁରୋଧକାରୀଙ୍କ ମୂଳ କାମକୁ ଯାଏ। ସମସ୍ତ ସହାୟକ କାମ ସରିଲେ ଏବଂ ବାହ୍ୟ ଅପେକ୍ଷା ନଥିଲେ ତାଙ୍କ କାମ ଚାଲୁଛି ବିଭାଗକୁ ଫେରେ।',
  'board.return.messageRequired': 'ଫେରାଇବା ପୂର୍ବରୁ ତଳେ “କଣ ବଦଳିଛି?” ରେ ଆବଶ୍ୟକ ସନ୍ଦେଶ ଲେଖନ୍ତୁ।',
  'board.return.confirm': 'ଏହି ସହାୟକ କାମକୁ ଆପଣଙ୍କ ବୋର୍ଡରୁ ହଟାଇ {owner}ଙ୍କୁ ସନ୍ଦେଶ ପଠାଇବେ: {title}? ଇତିହାସ ରହିବ। ଅନୁରୋଧକାରୀଙ୍କ ମୂଳ କାମକୁ ସମ୍ପୂର୍ଣ୍ଣ ଚିହ୍ନିତ କରାଯିବ ନାହିଁ।',
  'board.return.blockers': 'ଅସମାଧାନ ନିର୍ଭରତା',
  'board.return.resolveFirst': 'ଏହି କାମ ସାରିବା, ଫେରାଇବା କିମ୍ବା ହଟାଇବା ପୂର୍ବରୁ ଏହି ନିର୍ଭରତାଗୁଡ଼ିକ ସମାଧାନ କରନ୍ତୁ।',
  'board.return.parentSelected': 'ଏହି ବ୍ୟକ୍ତି ଆପଣଙ୍କ ସହାୟତା ମାଗିଛନ୍ତି। ତାଙ୍କୁ ପୁଣି ସହାୟକ କାମ ଦିଅନ୍ତୁ ନାହିଁ। ନିଜ ଭାଗ ସରିଥିଲେ “ମୋ ଭାଗ ସରିଛି — ଅନୁରୋଧକାରୀଙ୍କୁ ଫେରାନ୍ତୁ” ବାଛନ୍ତୁ।',
  'myDay.heading': 'ମୋ ଦିନ',
  'myDay.welcome': 'ଉପସ୍ଥାନ ଦିଅନ୍ତୁ, ଗୋଟିଏ ପାଦ ବଢ଼ାନ୍ତୁ ଏବଂ ଦଳକୁ ଜଣାନ୍ତୁ।',
  'myDay.title': 'କାମକୁ ଆଗକୁ ନେବା',
  'myDay.hint': 'ପ୍ରଥମେ ସମୟସୀମାର କାମ, ତାପରେ ଚାଲୁଥିବା କାମ।',
  'myDay.next': 'ପରବର୍ତ୍ତୀ ସମୀକ୍ଷା',
  'myDay.completed': 'ଆଜି {n} କାମ ସମ୍ପୂର୍ଣ୍ଣ',
  'myDay.open': 'ଆପଣଙ୍କ ବୋର୍ଡରେ {n} କାମ ବାକି',
  'myDay.progressHint': 'ସମ୍ପୂର୍ଣ୍ଣ କାମ ପାଇଁ ଆଜିର IST ତାରିଖ ବ୍ୟବହୃତ। ବାକି କାମ ସମ୍ପୂର୍ଣ୍ଣ ତାଲିକା, ଦୈନିକ ଲକ୍ଷ୍ୟ ନୁହେଁ।',
  'myDay.emptyHint': 'ଟିକିଏ ବିରାମ। ପ୍ରସ୍ତୁତ ହେଲେ କାମ ଯୋଡ଼ନ୍ତୁ।',
  'myDay.loadError': 'ଆପଣଙ୍କ କାମ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ। ଉପସ୍ଥାନ ପ୍ରଭାବିତ ହୁଏନାହିଁ।',
  'myDay.start': 'କାମ ଆରମ୍ଭ କରନ୍ତୁ',
  'myDay.update': 'ଶୀଘ୍ର ଅପଡେଟ୍',
  'myDay.finish': 'ସମ୍ପୂର୍ଣ୍ଣ ଚିହ୍ନଟ କରନ୍ତୁ',
  'myDay.help': 'ଅପେକ୍ଷା / ସାହାଯ୍ୟ ଦରକାର',
  'myDay.showAll': 'ସମସ୍ତ {n} ବାକି କାମ ଦେଖନ୍ତୁ',
  'myDay.showLess': 'କମ୍ କାମ ଦେଖାନ୍ତୁ',
  'myDay.add': 'ଆଉ କ’ଣ କରିବାକୁ ଅଛି?',
  'myDay.reviewTitle': 'ପଞ୍ଚ ଆଉଟ୍ ହୋଇଗଲା। ଏକ ଛୋଟ ସମୀକ୍ଷା?',
  'myDay.reviewHint': 'କେବଳ ସମ୍ପୂର୍ଣ୍ଣ କାମ ବାଛନ୍ତୁ। ଅନ୍ୟ କାମର ସ୍ଥିତି ଓ ସମୟସୀମା ବଦଳିବ ନାହିଁ, ପରଦିନ ପାଇଁ ବାକି ରହିବ।',
  'myDay.planHint': 'ଆରମ୍ଭ କରିବାକୁ କାମ ବାଛନ୍ତୁ ବା ଚାଲୁଥିବା କାମ ଜାରି ରଖନ୍ତୁ। ବାଛିନଥିବା କାମ ବଦଳିବ ନାହିଁ — କୌଣସି କାମ ସମ୍ପୂର୍ଣ୍ଣ ଚିହ୍ନଟ ହେବନାହିଁ।',
  'myDay.later': 'ଏହା ପରେ କରିବି',
  'myDay.carryForward': 'ସମସ୍ତ ବାକି କାମ ଖୋଲା ରଖନ୍ତୁ',
  'myDay.completeSelected': 'ବଛା କାମ ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ ({n})',
  'board.seen': 'ଦେଖାଯାଇଛି {date}',
  'board.delivered': 'ପହଞ୍ଚିଛି',
  'board.due.label': 'ସମୟସୀମା',
  'board.due.optional': 'ଶେଷ ତାରିଖ (ଇଚ୍ଛାଧୀନ)',
  'board.due.overdue': 'ସମୟସୀମା ଅତିକ୍ରମ',
  'board.due.today': 'ଆଜି ଶେଷ ତାରିଖ',
  'board.date.today': 'ଆଜି',
  'board.date.tomorrow': 'ଆସନ୍ତାକାଲି',
  'board.date.friday': 'ଏହି ଶୁକ୍ରବାର',
  'board.date.monday': 'ଆସନ୍ତା ସୋମବାର',
  'board.updates.title': 'କାର୍ଡ ଅଦ୍ୟତନ',
  'board.updates.prompt': 'କଣ ପରିବର୍ତ୍ତନ ହୋଇଛି?',
  'board.updates.waitingOn': 'କାହାକୁ ଅପେକ୍ଷା କରୁଛନ୍ତି (ଇଚ୍ଛାଧୀନ)',
  'board.updates.nextFollowup': 'ପରବର୍ତ୍ତୀ ଅନୁସରଣ (ଇଚ୍ଛାଧୀନ)',
  'board.updates.timeline': 'ଅଦ୍ୟତନ ଇତିହାସ',
  'board.updates.add': 'ଅଦ୍ୟତନ ଯୋଡ଼ନ୍ତୁ',
  'board.updates.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଅଦ୍ୟତନ ନାହିଁ।',
  'board.updates.unavailable': 'ଏହି କାର୍ଡ ଉପଲବ୍ଧ ନାହିଁ କିମ୍ବା ଆପଣଙ୍କ ପ୍ରବେଶ ନାହିଁ।',
  'board.updates.status': 'ସ୍ଥିତି',
  'board.status.on_track': 'ଠିକ୍ ପଥରେ',
  'board.status.waiting': 'ଅପେକ୍ଷାରେ',
  'board.status.blocked': 'ଅଟକିଛି',
  'board.status.done': 'ସମ୍ପୂର୍ଣ୍ଣ',
  'board.reminders.title': 'Omar ରୁ',
  'board.reminders.nudged': 'ଅଦ୍ୟତନ ମଗାଯାଇଛି।',
  'board.reminders.empty': 'ବର୍ତ୍ତମାନ କୌଣସି ପ୍ରଗତି ଯାଞ୍ଚ ଆବଶ୍ୟକ ନାହିଁ।',
  'board.reminders.dismiss': 'ଆଜି ପାଇଁ ବନ୍ଦ କରନ୍ତୁ',
  'board.quick.start': 'କାମ ଚାଲିଛି',
  'board.quick.done': 'ସମ୍ପୂର୍ଣ୍ଣ',
  'board.quick.text.on_track': 'ଏହି କାମ ଚାଲିଛି।',
  'board.quick.text.waiting': 'ଉତ୍ତରକୁ ଅପେକ୍ଷା କରୁଛି।',
  'board.quick.text.blocked': 'ବାଧା: ',
  'board.quick.text.done': 'ଏହି କାମ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି।',
  'board.create.step': '3 ରୁ ପଦକ୍ଷେପ {n}',
  'board.create.guidance': 'ଆପଣ ସମ୍ପୂର୍ଣ୍ଣ କରିପାରିବେ ଏପରି ଏକ ସ୍ପଷ୍ଟ କାମ ଲେଖନ୍ତୁ।',
  'board.create.back': 'ପଛକୁ',
  'board.create.next': 'ପରବର୍ତ୍ତୀ',
  'board.create.keepStatus': 'ଚୟନିତ ସ୍ତମ୍ଭ ରଖନ୍ତୁ',
  'common.loading': 'ଲୋଡ୍ ହେଉଛି...',
  'common.cancel': 'ବାତିଲ୍',
  'common.save': 'ସଞ୍ଚୟ',
  'common.saving': 'ସଞ୍ଚୟ ହେଉଛି...',
  'common.submit': 'ଦାଖଲ',
  'common.submitting': 'ଦାଖଲ ହେଉଛି...',
  'common.retry': 'ପୁନଃଚେଷ୍ଟା',
  'common.edit': 'ସମ୍ପାଦନ',
  'common.delete': 'ଡିଲିଟ୍',
  'common.close': 'ବନ୍ଦ',
  'common.location': 'ଅବସ୍ଥାନ',

  'a11y.rowActions': 'ଧାଡ଼ି କାର୍ଯ୍ୟ',

  'pagination.total': '{count} ମୋଟ',
  'pagination.pageOf': 'ପୃଷ୍ଠା {page} / {total}',
  'pagination.previous': 'ପୂର୍ବ',
  'pagination.next': 'ପରବର୍ତ୍ତୀ',

  'unit.hours': 'ଘ',
  'unit.days': 'ଦି',

  'lang.label': 'ଭାଷା',
  'lang.english': 'English',
  'lang.kannada': 'ಕನ್ನಡ',
  'lang.odia': 'ଓଡ଼ିଆ',
  'lang.hindi': 'हिन्दी',

  'login.brand.eyebrow': 'ସମୟ ଏବଂ ଉପସ୍ଥିତି',
  'login.brand.title': 'ପଞ୍ଚ ଇନ୍,\nଟ୍ରାକ୍‌ରେ ରୁହନ୍ତୁ।',
  'login.brand.subtitle': 'ଘଣ୍ଟା, କାମ ଏବଂ ଛୁଟି ଗୋଟିଏ ସ୍ଥାନରୁ ଟ୍ରାକ୍ କରନ୍ତୁ।',
  'login.brand.footer': 'କେବଳ ସ୍ଟାଫ୍ ପ୍ରବେଶ।',
  'login.signIn': 'ସାଇନ୍ ଇନ୍',
  'login.signInHint': 'ଆପଣଙ୍କ କାମ ଇମେଲ୍ ଏବଂ ପାସୱାର୍ଡ୍ ଦିଅନ୍ତୁ।',
  'login.email': 'ଇମେଲ୍',
  'login.password': 'ପାସୱାର୍ଡ୍',
  'login.passwordPlaceholder': 'ପାସୱାର୍ଡ୍ ଦିଅନ୍ତୁ',
  'login.signingIn': 'ସାଇନ୍ ଇନ୍ ହେଉଛି...',
  'login.emailPasswordRequired': 'ଇମେଲ୍ ଏବଂ ପାସୱାର୍ଡ୍ ଆବଶ୍ୟକ',
  'login.togglePassword': 'ପାସୱାର୍ଡ୍ ଦୃଶ୍ୟତା ବଦଳାନ୍ତୁ',
  'login.mfa.title': 'ଦୁଇ-ପଦକ୍ଷେପ ଯାଞ୍ଚ',
  'login.mfa.hint': 'ଆପଣଙ୍କ authenticator ଆପ୍‌ରୁ 6-ଅଙ୍କିଆ କୋଡ୍ ଦିଅନ୍ତୁ।',
  'login.mfa.code': 'ଯାଞ୍ଚ କୋଡ୍',
  'login.mfa.verify': 'ଯାଞ୍ଚ କରନ୍ତୁ',
  'login.mfa.verifying': 'ଯାଞ୍ଚ ହେଉଛି...',
  'login.mfa.codeRequired': 'authenticator ଆପ୍‌ରୁ 6-ଅଙ୍କିଆ କୋଡ୍ ଦିଅନ୍ତୁ',
  'login.setup.title': 'ଦୁଇ-ପଦକ୍ଷେପ ଯାଞ୍ଚ ସେଟ୍ କରନ୍ତୁ',
  'login.setup.hint': 'HR ଏବଂ admin ଆକାଉଣ୍ଟ୍‌ମାନଙ୍କ ପାଇଁ ଦୁଇ-ପଦକ୍ଷେପ ଯାଞ୍ଚ ଆବଶ୍ୟକ। ପ୍ରାୟ ଏକ ମିନିଟ୍।',
  'login.setup.scanHint':
    'Google Authenticator, Microsoft Authenticator, କିମ୍ବା 1Password ଭଳି authenticator ଆପ୍‌ରେ ଏହି QR କୋଡ୍ ସ୍କାନ୍ କରନ୍ତୁ।',
  'login.setup.qrAlt': 'Authenticator QR କୋଡ୍',
  'login.setup.manualSummary': 'ସ୍କାନ୍ ହେଉନାହିଁ? କୀ ମାନୁଆଲ୍ ଦିଅନ୍ତୁ',
  'login.setup.manualHint': 'ଆପଣଙ୍କ authenticator ଆପ୍‌ରେ ଏହି କୀ ଦିଅନ୍ତୁ:',
  'login.setup.codeLabel': 'ଆପ୍‌ରୁ 6-ଅଙ୍କିଆ କୋଡ୍ ଦିଅନ୍ତୁ',
  'login.setup.enabling': 'ସକ୍ରିୟ ହେଉଛି...',
  'login.setup.enable': 'ଦୁଇ-ପଦକ୍ଷେପ ଯାଞ୍ଚ ଚାଲୁ କରନ୍ତୁ',
  'login.setup.codeRequired': 'authenticator ଆପ୍‌ରେ ଦେଖାଯାଇଥିବା 6-ଅଙ୍କିଆ କୋଡ୍ ଦିଅନ୍ତୁ',

  'app.loading': 'ଲୋଡ୍ ହେଉଛି...',

  'footer.text': 'Teams · ବିଲ୍ଡ୍ {version}',

  'nav.self': 'ବ୍ୟକ୍ତିଗତ',
  'nav.today': 'ଆଜି',
  'nav.myRequests': 'ମୋ ଅନୁରୋଧ',
  'nav.board': 'ବୋର୍ଡ୍',
  'nav.teamBoard': 'ଟିମ୍ ବୋର୍ଡ୍',
  'nav.history': 'ଇତିହାସ',
  'nav.holidays': 'ଛୁଟି',
  'nav.handbook': 'ହ୍ୟାଣ୍ଡବୁକ୍',
  'nav.announcements': 'ଘୋଷଣା',

  'meta.today.title': 'ଆଜି',
  'meta.today.subtitle': 'ପଞ୍ଚ ଇନ୍/ଆଉଟ୍ ଏବଂ ଆପଣଙ୍କ ଦିନ କ’ଣ',
  'meta.today.exemptSubtitle': 'Your tasks, leave, and updates for today',
  'meta.board.title': 'ବୋର୍ଡ୍',
  'meta.board.subtitle': 'ଆପଣଙ୍କ ବ୍ୟକ୍ତିଗତ to-do ବୋର୍ଡ୍ — କାର୍ଡ୍ କଲମ୍‌ ମଧ୍ୟରେ ଟାଣନ୍ତୁ',
  'meta.teamBoard.title': 'ଟିମ୍ ବୋର୍ଡ୍',
  'meta.teamBoard.subtitle': 'ସମସ୍ତଙ୍କ କାର୍ଡ୍ — ସ୍ଥାନାନ୍ତର, ସମ୍ପାଦନ ଏବଂ ଡିଲିଟ୍',
  'meta.my_requests.title': 'ମୋ ଅନୁରୋଧ',
  'meta.my_requests.subtitle': 'ଆପଣ ଦାଖଲ ଛୁଟି, ବିଳମ୍ବ ଏବଂ ଶୀଘ୍ର ଛାଡ଼',
  'meta.history.title': 'ଇତିହାସ',
  'meta.history.subtitle': 'ଆପଣଙ୍କ ପଞ୍ଚ ଇତିହାସ',
  'meta.handbook.title': 'ହ୍ୟାଣ୍ଡବୁକ୍',
  'meta.handbook.subtitle': 'ଘୋଷଣା, ନିୟମ, HR ନୀତି ଏବଂ ଛୁଟି',

  'role.employee': 'କର୍ମଚାରୀ',
  'role.hr': 'HR',
  'role.admin': 'Admin',
  'shell.logout': 'ଲଗ୍ ଆଉଟ୍',
  'shell.openNav': 'ନାଭିଗେସନ୍ ଖୋଲନ୍ତୁ',
  'shell.closeNav': 'ନାଭିଗେସନ୍ ବନ୍ଦ',
  'shell.themeLight': 'ଲାଇଟ୍ ଥିମ୍‌କୁ ବଦଳାନ୍ତୁ',
  'shell.themeDark': 'ଡାର୍କ୍ ଥିମ୍‌କୁ ବଦଳାନ୍ତୁ',
  'shell.primaryNav': 'ମୁଖ୍ୟ ନେଭିଗେସନ୍',
  'shell.more': 'ଅଧିକ',
  'shell.moreHint': 'ଆପଣଙ୍କ ପାଇଁ ଉପଲବ୍ଧ ପୃଷ୍ଠା ଏବଂ ଆକାଉଣ୍ଟ ନିୟନ୍ତ୍ରଣ।',
  'shell.accountControls': 'ଆକାଉଣ୍ଟ ନିୟନ୍ତ୍ରଣ',
  'shell.muteSounds': 'ଧ୍ୱନି ବନ୍ଦ କରନ୍ତୁ',
  'shell.enableSounds': 'ଧ୍ୱନି ସକ୍ରିୟ କରନ୍ତୁ',

  'notify.title': 'ବିଜ୍ଞପ୍ତି',
  'notify.markAllRead': 'ସବୁ ପଢ଼ା ଚିହ୍ନିତ',
  'notify.enablePush': 'ପୁଶ୍ ବିଜ୍ଞପ୍ତି ସକ୍ରିୟ',
  'notify.enabling': 'ସକ୍ରିୟ ହେଉଛି...',
  'notify.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କono ବିଜ୍ଞପ୍ତି ନାହିଁ।',
  'notify.justNow': 'ଏବେ',
  'notify.minutesAgo': '{n} ମି. ପୂର୍ବେ',
  'notify.hoursAgo': '{n} ଘ. ପୂର୍ବେ',
  'notify.daysAgo': '{n} ଦି. ପୂର୍ବେ',
  'notify.pushEnabled': 'ପୁଶ୍ ବିଜ୍ଞପ୍ତି ସକ୍ରିୟ ହେଲା।',
  'notify.pushFailed': 'ପୁଶ୍ ବିଜ୍ଞପ୍ତି ସକ୍ରିୟ ହୋଇପାରିଲା ନାହିଁ।',

  'dashboard.loading': 'ଡ୍ୟାସବୋର୍ଡ୍ ଲୋଡ୍ ହେଉଛି...',
  'dashboard.error': 'ଡ୍ୟାସବୋର୍ଡ୍ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'dashboard.onLeave': 'ଛୁଟିରେ',
  'dashboard.onClock': 'କ୍ଲକ୍‌ରେ',
  'dashboard.offClock': 'କ୍ଲକ୍‌ ବାହାରେ',
  'dashboard.attendanceExempt': 'Attendance exempt',
  'dashboard.attendanceNotRequired': 'No punch-in required',
  'dashboard.attendanceExemptHint': 'Your account is not part of attendance tracking.',
  'dashboard.onLeaveToday': 'ଆଜି ଆପଣ ଅନୁମୋଦିତ ଛୁଟିରେ',
  'dashboard.onLeaveDisabled': 'ଛୁଟିରେ ଥିବାବେଳେ ପଞ୍ଚ ଇନ୍ ଅକ୍ଷମ।',
  'dashboard.inSince': '{time} ରୁ ଭିତରେ',
  'dashboard.soFar': 'ଏପର୍ଯ୍ୟନ୍ତ',
  'dashboard.notPunchedIn': 'ପଞ୍ଚ ଇନ୍ ହୋଇନାହିଁ',
  'dashboard.punchInHint': 'କାମ ଆରମ୍ଭ କଲାବେଳେ ପଞ୍ଚ ଇନ୍ କରନ୍ତୁ।',
  'dashboard.punchIn': 'ପଞ୍ଚ ଇନ୍',
  'dashboard.punchOut': 'ପଞ୍ଚ ଆଉଟ୍',
  'dashboard.stat.today': 'ଆଜି',
  'dashboard.stat.week': 'ଏହି ସପ୍ତାହ',
  'dashboard.stat.leaveLeft': 'ବାକି ଛୁଟି',
  'dashboard.stat.openCards': 'ଖୋଲା କାର୍ଡ୍',
  'dashboard.myTasks': 'ମୋ କାମ',
  'dashboard.myTasksHint': 'ଆପଣଙ୍କ ବ୍ୟକ୍ତିଗତ ବୋର୍ଡ୍‌ରେ ଖୋଲା କାର୍ଡ୍।',
  'dashboard.viewBoard': 'ବୋର୍ଡ୍ ଖୋଲନ୍ତୁ',
  'dashboard.noOpenTasks': 'ଖୋଲା କାମ ନାହିଁ — ଆପଣଙ୍କ ବୋର୍ଡ୍ ପରିଷ୍କାର।',
  'dashboard.leave': 'ଛୁଟି',
  'dashboard.leaveThrough': '{date} ପର୍ଯ୍ୟନ୍ତ ଛୁଟିରେ',
  'dashboard.days': 'ଦିନ',
  'dashboard.upcomingLeave': 'ଆଗାମୀ ଛୁଟି: {start} – {end}.',
  'dashboard.noLeaveScheduled': 'କono ଅନୁମୋଦିତ ଛୁଟି ନିର୍ଦ୍ଧାରିତ ନାହିଁ।',
  'dashboard.pendingRequests': '{n} ଅନୁରୋଧ ଅନୁମୋଦନ ବାକି।',
  'dashboard.yourLeave': 'ଆପଣଙ୍କ ଛୁଟି',
  'dashboard.noLeaveTypes': 'ଏପର୍ଯ୍ୟନ୍ତ ଛୁଟି ପ୍ରକାର ସେଟ୍ ହୋଇନାହିଁ।',
  'dashboard.announcements': 'ଘୋଷଣା',
  'dashboard.noAnnouncements': 'ଏପର୍ଯ୍ୟନ୍ତ କono ଘୋଷଣା ନାହିଁ।',
  'dashboard.toast.punchedInZone': '{zone} ରେ ପଞ୍ଚ ଇନ୍।',
  'dashboard.toast.punchedIn': 'ଆପଣ ପଞ୍ଚ ଇନ୍ ଅଛନ୍ତି।',
  'dashboard.toast.punchedInLate': 'ଆପଣ {minutes} ମିନିଟ୍ ବିଳମ୍ବରେ ଆସିଛନ୍ତି।',
  'dashboard.toast.punchedOut': 'ଆପଣ ପଞ୍ଚ ଆଉଟ୍ ଅଛନ୍ତି।',

  'punch.board.emptyTitle': 'ଆଜି ଆପଣ କ’ଣ କାମ କରୁଛନ୍ତି?',
  'punch.board.emptyHint': 'ଆଜିର ପାଇଁ ଗୋଟିଏ କାମ ଯୋଡ଼ନ୍ତୁ, କିମ୍ବା ନିୟୋଜିତ କାମ ନାହିଁ ବୋଲି ଲଗ୍ କରନ୍ତୁ।',
  'punch.board.pickWorkTitle': 'ଆଜି ଆପଣ କ’ଣ କାମ କରୁଛନ୍ତି?',
  'punch.board.pickWorkHint': 'ନିମ୍ନରେ ଆଜିର ଯୋଜନା କରନ୍ତୁ। ଚେକ୍ ହୋଇଥିବା କାମ ବଛାଯାଇଛି; ହଟାଇବାକୁ ପୁଣି ଟ୍ୟାପ୍ କରନ୍ତୁ।',
  'punch.board.groupOngoing': 'ଚାଲୁଥିବା',
  'punch.board.groupAvailable': 'ଉପଲବ୍ଧ',
  'punch.board.groupBlocked': 'ଅବରୁଦ୍ଧ — ଧ୍ୟାନ ଆବଶ୍ୟକ',
  'punch.board.blockedHint': 'ଏଗୁଡ଼ିକ ସୂଚନା ପାଇଁ ଦେଖାଯାଇଛି। ପୁଣି ଆରମ୍ଭ କରିବା ପୂର୍ବରୁ ବୋର୍ଡରେ ଅବରୋଧ ସମାଧାନ କରନ୍ତୁ।',
  'punch.board.todayPlan': 'ଆଜିର ଯୋଜନା',
  'punch.board.selectedCount': '{n}ଟି ବଛାଯାଇଛି',
  'punch.board.selected': 'ବଛାଯାଇଛି',
  'punch.board.notSelected': 'ବଛାଯାଇନାହିଁ',
  'punch.board.continueToday': 'ଆଜି ଜାରି ରଖନ୍ତୁ',
  'punch.board.willMarkDone': 'ଆଜିର ଯୋଜନାରେ ନାହିଁ — ସମାପ୍ତ ଚିହ୍ନିତ ହେବ',
  'punch.board.startToday': 'ଆଜି ଆରମ୍ଭ କରନ୍ତୁ',
  'punch.board.staysTodo': 'କରିବା ତାଲିକାରେ ରହିବ',
  'punch.board.confirmSelected': '{n}ଟି କାମ ସହ ଦିନ ଆରମ୍ଭ କରନ୍ତୁ',
  'punch.board.confirmNone': 'ଚାଲୁଥିବା କାମଗୁଡ଼ିକୁ ସମାପ୍ତ ଚିହ୍ନିତ କରନ୍ତୁ',
  'punch.board.selectTask': 'ଅତି କମରେ ଗୋଟିଏ କାମ ବାଛନ୍ତୁ',
  'punch.board.blockedOnlyHint': 'ଆପଣଙ୍କ ନିୟୋଜିତ କାମଗୁଡ଼ିକ ଅବରୁଦ୍ଧ। କେଉଁଥିରେ ଧ୍ୟାନ ଦରକାର ଦେଖନ୍ତୁ, ତାପରେ ଆଜିର ଅନ୍ୟ କାମ ଯୋଡ଼ନ୍ତୁ କିମ୍ବା ଉପଲବ୍ଧ କାମ ନାହିଁ ବୋଲି ଲଗ୍ କରନ୍ତୁ।',
  'punch.board.doingDoneTitle': 'ଏଗୁଡ଼ିକ ସମାପ୍ତ ହେଲା କି?',
  'punch.board.doingDoneHint': 'ସମାପ୍ତ କରିଥିବା କାମ ବାଛନ୍ତୁ।',
  'punch.board.pickTodoTitle': 'ଆପଣ କ’ଣ କରିବେ?',
  'punch.board.pickTodoHint': 'doing ରେ ନେବାକୁ କାର୍ଡ୍ ବାଛନ୍ତୁ।',
  'punch.board.skip': 'ଛାଡ଼ନ୍ତୁ',
  'punch.board.confirm': 'ନିଶ୍ଚିତ କରନ୍ତୁ',
  'punch.board.toast.markedDone': 'ସମାପ୍ତ ଭାବରେ ଚିହ୍ନିତ।',
  'punch.board.toast.started': 'doing ରେ ସରିଗଲା।',
  'punch.board.toast.confirmed': 'କାମ ଅପଡେଟ୍ ହେଲା।',

  'punchIn.title': 'ପଞ୍ଚ ଇନ୍',
  'punchIn.home.title': 'ଦୟାକରି ଘର କିମ୍ବା ଅଫିସରୁ ପଞ୍ଚ ଇନ୍ କରନ୍ତୁ।',
  'punchIn.home.hint': 'ଅଫିସରେ ଥିଲେ Office ଦେଖାଯିବ। ଅନ୍ୟତ୍ର Home।',
  'punchIn.untagged': 'Sales ପଞ୍ଚ — roster ରେ Sales ଦେଖାଯିବ। GPS ଅବସ୍ଥାନ ଆବଶ୍ୟକ ଏବଂ ରେକର୍ଡ ହୁଏ; geofence ନାହିଁ।',
  'punchIn.gettingLocation': 'ଆପଣଙ୍କ ଅବସ୍ଥାନ ମିଳୁଛି...',
  'punchIn.atSite': '{name} ରେ',
  'punchIn.locationCaptured': 'ଅବସ୍ଥାନ ଧରାଯାଇଛି ({lat}, {lng})',
  'punchIn.refreshLocation': 'Refresh location',
  'punchIn.outsideSiteHint': 'Outside {name} radius: {distance} m away (radius {radius} m). Refresh location, check this site\'s location permission, or ask HR for help.',
  'punchIn.geoUnsupported': 'ଏହି ବ୍ରାଉଜର୍ geolocation ସମର୍ଥନ କରେ ନାହିଁ।',
  'punchIn.geoDenied': 'ଅବସ୍ଥାନ ପ୍ରବେଶ ଅଗ୍ରାହ୍ୟ। ଦୟାକରି ଅନୁମତି ଦିଅନ୍ତୁ ଏବଂ ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।',
  'punchIn.geoError': 'ଆପଣଙ୍କ ଅବସ୍ଥାନ ନିର୍ଦ୍ଧାରଣ ହୋଇପାରିଲା ନାହିଁ ({msg})।',
  'punchIn.you': 'ଆପଣ',
  'punchIn.kmTo': '— {name} ଠାରୁ {km} km',
  'punchIn.placeDetails': 'ସ୍ଥାନର ବିବରଣୀ (ଇଚ୍ଛାଧୀନ)',
  'punchIn.lookingUp': 'ସ୍ଥାନ ଖୋଜାଯାଉଛି — ଆପଣ ଏବେ ପଞ୍ଚ କରିପାରିବେ।',
  'punchIn.placeName': 'ସ୍ଥାନର ନାମ (ଇଚ୍ଛାଧୀନ)',
  'punchIn.area': 'ଅଞ୍ଚଳ (ଇଚ୍ଛାଧୀନ)',
  'punchIn.nameHint': 'ଆପଣଙ୍କ GPS ସ୍ଥାନ ଯଥେଷ୍ଟ। ଚାହିଁଲେ ସ୍ଥାନର ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ ବା ସୁଧାରନ୍ତୁ, କିମ୍ବା ଖାଲି ଛାଡ଼ନ୍ତୁ। ହୋଟେଲ୍ କିମ୍ବା Maps ଲିଙ୍କ ଦରକାର ନାହିଁ।',
  'punchIn.punchingIn': 'ପଞ୍ଚ ଇନ୍ ହେଉଛି...',
  'punchIn.fallbackHome': 'ଘର',
  'punchIn.fallbackField': 'କ୍ଷେତ୍ର',

  'punchOut.title': 'ପଞ୍ଚ ଆଉଟ୍',
  'punchOut.home.title': 'ଦୟାକରି ଘର କିମ୍ବା ଅଫିସରୁ ପଞ୍ଚ ଆଉଟ୍ କରନ୍ତୁ।',
  'punchOut.untagged': 'କ୍ଲକ୍ ଆଉଟ୍। Sales ପଞ୍ଚ ପାଇଁ GPS ଅବସ୍ଥାନ ଆବଶ୍ୟକ ଏବଂ ରେକର୍ଡ ହୁଏ।',
  'punchOut.punchingOut': 'ପଞ୍ଚ ଆଉଟ୍ ହେଉଛି...',

  'requests.new': 'ନୂଆ ଅନୁରୋଧ',
  'requests.error': 'ଅନୁରୋଧ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'requests.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କono ଅନୁରୋଧ ନାହିଁ',
  'requests.edit': 'ଅନୁରୋଧ ସମ୍ପାଦନ',
  'requests.fullRequest': 'ସମ୍ପୂର୍ଣ୍ଣ ଅନୁରୋଧ',
  'requests.type': 'ପ୍ରକାର',
  'requests.type.leave': 'ଛୁଟି',
  'requests.type.late': 'ବିଳମ୍ବ',
  'requests.type.early_leaving': 'ଶୀଘ୍ର ଛାଡ଼',
  'requests.type.other': 'ଅନ୍ୟ',
  'requests.startDate': 'ଆରମ୍ଭ ତାରିଖ',
  'requests.endDate': 'ଶେଷ ତାରିଖ',
  'requests.halfDay': 'ଅଧା ଦିନ',
  'requests.leaveType': 'ଛୁଟି ପ୍ରକାର',
  'requests.selectLeaveType': 'ଛୁଟି ପ୍ରକାର ବାଛନ୍ତୁ...',
  'requests.leaveTypeLabel': '{name} — {remaining} / {quota} ବାକି',
  'requests.reasonCategory': 'କାରଣ ଶ୍ରେଣୀ',
  'requests.selectCategory': 'ଶ୍ରେଣୀ ବାଛନ୍ତୁ...',
  'requests.reason': 'କାରଣ',
  'requests.date': 'ତାରିଖ',
  'requests.status': 'ସ୍ଥିତି',
  'requests.businessDays': '≈ {n} ବ୍ୟବସାୟିକ ଦିନ।',
  'requests.lateHint': 'ଟ୍ରାକିଂ ପାଇଁ ଲଗ୍, ଅନୁମୋଦନ ଆବଶ୍ୟକ ନାହିଁ।',
  'requests.error.datesRequired': 'ଆରମ୍ଭ ଏବଂ ଶେଷ ତାରିଖ ଆବଶ୍ୟକ।',
  'requests.error.leaveTypeRequired': 'ଛୁଟି ପ୍ରକାର ଆବଶ୍ୟକ।',
  'requests.error.dateRequired': 'ତାରିଖ ଆବଶ୍ୟକ।',
  'requests.error.reasonRequired': 'କାରଣ ଆବଶ୍ୟକ।',
  'requests.toast.updated': 'ଅନୁରୋଧ ଅପଡେଟ୍ ହେଲା।',
  'requests.toast.submitted': 'ଅନୁରୋଧ ଦାଖଲ ହେଲା।',
  'requests.toast.deleted': 'ଅନୁରୋଧ ଡିଲିଟ୍ ହେଲା।',
  'requests.confirmDelete': 'ଏହି ଅନୁରୋଧ ଡିଲିଟ୍ କରିବେ?',
  'requests.status.pending': 'ବାକି',
  'requests.status.approved': 'ଅନୁମୋଦିତ',
  'requests.status.rejected': 'ପ୍ରତ୍ୟାଖ୍ୟାନ',
  'requests.status.logged': 'ଲଗ୍',
  'requests.category.sick': 'ଅସୁସ୍ଥ',
  'requests.category.personal': 'ବ୍ୟକ୍ତିଗତ',
  'requests.category.vacation': 'ଛୁଟି',
  'requests.category.family': 'ପରିବାର',
  'requests.category.bereavement': 'ଶୋକ',
  'requests.category.menstrual': 'ଋତୁସ୍ରାବ',
  'requests.category.other': 'ଅନ୍ୟ',

  'board.noWorkToday': 'ଆଜି ମୋ ପାଇଁ କାମ ନାହିଁ',
  'board.loggedToday': 'ଆଜି ଲଗ୍',
  'board.loggedTodayTitle': 'ଆପଣ ଆଜି ପୂର୍ବରୁ ଲଗ୍ କରିଛନ୍ତି।',
  'board.error': 'ଆପଣଙ୍କ ବୋର୍ଡ୍ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'board.emptyBoard': 'ଏପର୍ଯ୍ୟନ୍ତ କାର୍ଡ୍ ନାହିଁ — ଆରମ୍ଭ କରିବାକୁ ଗୋଟିଏ ଯୋଡ଼ନ୍ତୁ।',
  'board.column.todo': 'କରିବ',
  'board.column.doing': 'କରୁଛି',
  'board.column.blocked': 'ଅବରୁଦ୍ଧ',
  'board.column.done': 'ସମାପ୍ତ',
  'board.columnAria': 'ବୋର୍ଡ୍ କଲମ୍',
  'board.addCard': 'କାର୍ଡ୍ ଯୋଡ଼ନ୍ତୁ',
  'board.addCardTo': '{col} ରେ କାର୍ଡ୍ ଯୋଡ଼ନ୍ତୁ',
  'board.editCard': 'କାର୍ଡ୍ ସମ୍ପାଦନ',
  'board.newCard': 'ନୂଆ କାର୍ଡ୍ — {col}',
  'board.title': 'ଶୀର୍ଷକ',
  'board.description': 'ବର୍ଣ୍ଣନା',
  'board.error.titleRequired': 'ଶୀର୍ଷକ ଆବଶ୍ୟକ।',
  'board.toast.updated': 'କାର୍ଡ୍ ଅପଡେଟ୍ ହେଲା।',
  'board.toast.created': 'କାର୍ଡ୍ ତିଆରି ହେଲା।',
  'board.toast.deleted': 'କାର୍ଡ୍ ଡିଲିଟ୍ ହେଲା।',
  'board.toast.moved': '{col} କୁ ସ୍ଥାନାନ୍ତର।',
  'board.toast.logged': 'ଲଗ୍ ହେଲା।',
  'board.confirmDelete': '"{title}" ଡିଲିଟ୍ କରିବେ?',
  'board.moveTo': '{col} କୁ ନିଅନ୍ତୁ',
  'board.deleteCard': 'କାର୍ଡ୍ ଡିଲିଟ୍',
  'board.doneAt': 'ସମାପ୍ତ {date}',
  'board.fromLabel': '{label} ରୁ',
  'board.myTask': 'ଆପଣଙ୍କ କାର୍ଯ୍ୟ',
  'board.source.commandCentre': 'Command Centre',
  'board.source.chiefOfStaff': 'Omar',
  'board.sharedProgress': 'Shared: {completed}/{total}', 'board.blockedReason': 'Blocked: {reason}', 'board.blockedExternal': 'Waiting on {name}', 'board.helpers': 'Helpers: {helpers}', 'board.blocking': 'Blocking {user}: {title}', 'board.toast.blocked': 'Task blocked and helpers notified.',
  'board.block.title': 'Block task', 'board.block.intro': 'Add helper tasks needed to unblock “{title}”.', 'board.block.reason': 'What is blocked?', 'board.block.modeLabel': 'Blocking type', 'board.block.modeHelpers': 'Hand over to teammate', 'board.block.modeExternal': 'External party', 'board.block.externalName': 'External party name', 'board.block.externalNamePlaceholder': 'e.g. Shafiq sir, vendor name', 'board.block.externalGuidance': 'Use this only when nobody inside the company can unblock it. Name the person or party and describe what is awaited above.', 'board.block.missingInfoCta': 'Add blocking info: name a teammate or external party.', 'board.block.setInfo': 'Set blocking info', 'board.block.firstNameGuidance': 'Enter the helper’s exact full first name. If more than one person has that name, select the right person below.', 'board.block.helperNumber': 'Helper {n}', 'board.block.helperFirstName': 'Helper first name', 'board.block.helperPerson': 'Helper', 'board.block.helperPersonPlaceholder': 'Select a teammate', 'board.block.selectedHelper': 'Selected: {name}', 'board.block.matches': 'Matching helpers', 'board.block.helperTask': 'Helper task', 'board.block.removeHelper': 'Remove helper', 'board.block.addHelper': 'Add another helper', 'board.block.submit': 'Block task',

  'teamBoard.readOnly': 'କେବଳ ପଢ଼ିବା ଟିମ୍ ଦୃଶ୍ୟ',
  'teamBoard.filterAll': 'ସମସ୍ତେ',
  'teamBoard.filterPeople': 'ବ୍ୟକ୍ତି ଅନୁସାରେ ଫିଲ୍ଟର୍',
  'teamBoard.people': 'ଲୋକ',
  'teamBoard.peopleSelected': '{n} ଜଣ',
  'teamBoard.selectPeople': 'ଲୋକ ବାଛନ୍ତୁ',
  'teamBoard.error': 'ଟିମ୍ ବୋର୍ଡ୍ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'teamBoard.emptyColumn': 'କାର୍ଡ୍ ନାହିଁ',
  'teamBoard.newCardFor': '{person} ପାଇଁ ନୂଆ କାର୍ଡ୍ — {col}',
  'teamBoard.composerLabel': 'କାମ ନିଯୁକ୍ତ କରନ୍ତୁ',
  'teamBoard.composerPlaceholder': 'Type @ to add people', 'teamBoard.composerTaskPlaceholder': 'Task for selected people', 'teamBoard.removeRecipient': 'Remove {name}',
  'teamBoard.composerInvalid': 'ପରାମର୍ଶରୁ ବ୍ୟକ୍ତି ବାଛନ୍ତୁ ଏବଂ କାମ ଲେଖନ୍ତୁ।',
  'teamBoard.assign': 'ନିଯୁକ୍ତ କରନ୍ତୁ',
  'teamBoard.searchCards': 'କାର୍ଡ୍ କିମ୍ବା ଲୋକ ଖୋଜନ୍ତୁ',
  'teamBoard.searchPeople': 'ଲୋକ ଖୋଜନ୍ତୁ',
  'teamBoard.noPeopleMatch': 'ମେଳ ଖାଉଥିବା ଲୋକ ନାହାନ୍ତି।',
  'teamBoard.summary': '{total} କାର୍ଡ୍‌ରୁ {shown} ଦେଖାଯାଉଛି',
  'teamBoard.emptyBoard': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଟିମ୍ କାର୍ଡ୍ ନାହିଁ।',
  'teamBoard.emptySearch': 'ଆପଣଙ୍କ ଖୋଜ ସହ କୌଣସି କାର୍ଡ୍ ମେଳ ଖାଉନାହିଁ।',
  'teamBoard.clearFilters': 'ଫିଲ୍ଟର୍ ସଫା କରନ୍ତୁ',
  'teamBoard.attention': 'Attention',
  'teamBoard.attentionTitle': 'Needs attention',
  'teamBoard.attentionEmpty': 'Nothing blocked, nothing stale. Every board is moving.',
  'teamBoard.attentionBlocked': 'Blocked ({n})',
  'teamBoard.attentionStale': 'Stuck in Doing 3+ days ({n})',
  'teamBoard.attentionStaleAge': '{age} in Doing',
  'teamBoard.ageDays': '{n}d',
  'teamBoard.usage': 'Usage',
  'teamBoard.usageTitle': 'Board usage',
  'teamBoard.usageName': 'Name',
  'teamBoard.usageLastOpened': 'Last opened',
  'teamBoard.usageOpens': 'Opens',
  'teamBoard.usageNever': 'Never',
  'teamBoard.usageAgo': '{n}d ago',
  'fieldAttention.subtitle': 'Blocked chains and work sitting in Doing across your field team.',
  'fieldAttention.error': 'Could not load the field board.',
  'teamBoard.activity': 'କାର୍ଯ୍ୟକଳାପ',
  'teamBoard.activityTitle': 'ବୋର୍ଡ୍ କାର୍ଯ୍ୟକଳାପ',
  'teamBoard.activityLoading': 'କାର୍ଯ୍ୟକଳାପ ଲୋଡ୍ ହେଉଛି...',
  'teamBoard.activityEmpty': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟକଳାପ ନାହିଁ।',
  'teamBoard.activitySystem': 'ସିଷ୍ଟମ୍',

  'noWork.title': 'ଆଜି କାମ ନାହିଁ?',
  'noWork.intro':
    'ଆଜି ନିୟୋଜିତ କାମ ନାହିଁ? ବଦଳରେ ଯାହା ଉଠାଇଛନ୍ତି ଲଗ୍ କରନ୍ତୁ — housekeeping, ଆପଣଙ୍କ କାର୍ଡ୍, କିମ୍ବା ସାହାଯ୍ୟ ବିଷୟରେ ଟିପ୍ପଣୀ।',
  'noWork.kind.housekeeping': 'Housekeeping',
  'noWork.kind.ownCard': 'ମୋ କାର୍ଡ୍‌ରୁ ଗୋଟିଏ',
  'noWork.kind.note': 'ଛୋଟ ଟିପ୍ପଣୀ',
  'noWork.housekeepingItem': 'Housekeeping ଆଇଟମ୍',
  'noWork.noHousekeeping': 'Housekeeping ଆଇଟମ୍ ସେଟ୍ ହୋଇନାହିଁ — ଅନ୍ୟ ବାଛନ୍ତୁ।',
  'noWork.choose': '— ବାଛନ୍ତୁ —',
  'noWork.yourCard': 'ଆପଣଙ୍କ କାର୍ଡ୍',
  'noWork.noCards': 'ଖୋଲା to-do କିମ୍ବା blocked କାର୍ଡ୍ ନାହିଁ — ଅନ୍ୟ ବାଛନ୍ତୁ।',
  'noWork.note': 'ଟିପ୍ପଣୀ',
  'noWork.notePlaceholder': 'ଯଥା Ravi ଙ୍କ site survey ରେ ସାହାଯ୍ୟ',
  'noWork.error.pickOne': 'ନିମ୍ନ ତିନି ବିକଳ୍ପରୁ ଗୋଟିଏ ବାଛନ୍ତୁ।',
  'noWork.logIt': 'ଲଗ୍ କରନ୍ତୁ',
  'noWork.recent': 'ସାମ୍ପ୍ରତିକ',
  'noWork.describe.ownCard': 'ମୋ କାର୍ଡ୍‌ରୁ ଗୋଟିଏ',
  'noWork.describe.housekeeping': 'housekeeping',

  'history.error': 'କାମ ଲଗ୍ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'history.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କono କାମ ଲଗ୍ ନାହିଁ',
  'history.date': 'ତାରିଖ',
  'history.in': 'ଇନ୍',
  'history.out': 'ଆଉଟ୍',
  'history.duration': 'ଅବଧି',
  'history.site': 'ସାଇଟ୍',
  'history.tasks': 'କାମ',
  'history.inProgress': 'ଚାଲିଛି',
  'history.remote': 'Remote',

  'holidays.subtitle': 'ଜାତୀୟ ଏବଂ କମ୍ପାନୀ ଛୁଟି।',
  'holidays.error': 'ଛୁଟି ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'holidays.national': 'ଜାତୀୟ ଛୁଟି',
  'holidays.company': 'କମ୍ପାନୀ ଛୁଟି',
  'holidays.upcoming': 'ଆଗାମୀ',
  'holidays.empty': 'କono ଛୁଟି ତାଲିକାଭୁକ୍ତ ନାହିଁ।',

  'announcements.subtitle': 'HR ରୁ କମ୍ପାନୀ-ବ୍ୟାପୀ ଅପଡେଟ୍।',
  'announcements.error': 'ଘୋଷଣା ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
  'announcements.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କono ଘୋଷଣା ନାହିଁ।',
  'announcements.authorFallback': 'HR',

  'policy.error': 'ଏହି ନୀତି ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',

  'leave.hint.endBeforeStart': 'ଶେଷ ତାରିଖ ଆରମ୍ଭ ତାରିଖ ପରେ କିମ୍ବା ସମାନ ହେବା ଉଚିତ।',
  'leave.hint.startTooPast': 'ଆରମ୍ଭ ତାରିଖ 7 ଦିନ ଠାରୁ ଅଧିକ ପୂର୍ବ ହୋଇପାରିବ ନାହିଁ।',
  'leave.hint.startTooFuture': 'ଆରମ୍ଭ ତାରିଖ 1 ବର୍ଷ ଠାରୁ ଅଧିକ ଆଗକୁ ହୋଇପାରିବ ନାହିଁ।',
  'leave.hint.tooLong': 'ଛୁଟି ଅନୁରୋଧ 30 ଦିନରୁ ଅଧିକ ହୋଇପାରିବ ନାହିଁ।'
};

export default or;
